export default __webpack_public_path__ + "static/media/38DegreeCurve.5958d24a.jpg";